import {
  type Activities_Bool_Exp,
  Lead_Agent_Source_Enum_Enum,
} from '@graphql/__generated__/graphql';

/**
 * Assignments the owner initiated (a contact request from the result page,
 * an accepted prospection-map request). They record provenance and are never
 * displaced by a CRM reassignment: the Hasura delete permissions on
 * lead_agents exclude them, realadvisor.api's assignLeadsToBroker skips them,
 * and the CRM keeps them out of its own reassignment queries.
 */
export const OWNER_INITIATED_LEAD_AGENT_SOURCES = [
  Lead_Agent_Source_Enum_Enum.ResultPage,
  Lead_Agent_Source_Enum_Enum.ProspectionMap,
] as const;

export const isOwnerInitiatedLeadAgentSource = (
  source: string | null | undefined,
): boolean =>
  source != null &&
  (OWNER_INITIATED_LEAD_AGENT_SOURCES as readonly string[]).includes(source);

/**
 * Filter for the open assignment tasks a reassignment to `brokerId` may close:
 * a teammate who keeps an accepted prospection-map assignment on the lead
 * keeps their task too (same rule as realadvisor.api's assignLeadsToBroker).
 */
export const keepsProspectionAssignmentTask = ({
  leadId,
  brokerId,
}: {
  leadId: string;
  brokerId: string;
}): Activities_Bool_Exp => ({
  _not: {
    assignee: {
      id: { _neq: brokerId },
      lead_agents: {
        lead_id: { _eq: leadId },
        passed_at: { _is_null: true },
        source: { _eq: Lead_Agent_Source_Enum_Enum.ProspectionMap },
      },
    },
  },
});
